export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    // Check if this is a bundle submission (has slip dress)
    const hasSlipBundle = this.form.querySelector('[name="items[1][id]"]')

    if (hasSlipBundle) {
      const mainVariantId = this.form.querySelector('[name="id"]')?.value
      const timestamp = Date.now()
      const bundleId = `${mainVariantId}_${timestamp}`

      // Create and append bundle ID input for main product
      const mainBundleInput = document.createElement('input')
      mainBundleInput.type = 'hidden'
      mainBundleInput.name = 'properties[__venn_bundle_id]'
      mainBundleInput.value = bundleId
      this.form.appendChild(mainBundleInput)

      // Create and append bundle ID input for slip product
      const slipBundleInput = document.createElement('input')
      slipBundleInput.type = 'hidden'
      slipBundleInput.name = 'items[1][properties][__venn_bundle_id]'
      slipBundleInput.value = bundleId
      this.form.appendChild(slipBundleInput)
    }

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  handleErrorMessage (errorMessage = false) {
    // Only show errors if error elements exist
    if (!this.els['error-wrapper']?.exists || !this.els['error-message']?.exists) {
      return
    }

    this.els['error-wrapper'].element.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.els['error-message'].element.textContent = errorMessage
    }
  }

  /**
   * Toggles the add to cart button state
   * @param {boolean} disable - Whether to disable the button
   * @param {string} text - Optional text to display on the button
   * @param {boolean} modifyClass - Whether to modify classes (kept for backwards compatibility)
   */
  toggleAddButton (disable = true, text, modifyClass = true) {
    if (!this.els.submit.exists) return

    const addButton = this.els.submit.element
    const addButtonText = addButton.querySelector('span')
    if (!addButtonText) return

    const isPreorder = addButton.dataset.preorder

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else if (isPreorder) {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.preorder
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }
  }

  /**
   * Sets the button to unavailable state
   */
  setUnavailable () {
    if (!this.els.submit.exists) return

    const addButton = this.els.submit.element
    const addButtonText = addButton.querySelector('span')

    if (!addButtonText) return
    addButtonText.textContent = window.variantStrings.unavailable
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
